<template>
  <v-card
    outlined
    class="pa-4 clickable-card"
    :class="[{ 'selected-card': isSelected, 'mb-3': !last }]"
    @click="handleClick"
  >
    <div class="d-flex align-center">
      <v-icon left :color="iconColor">{{ icon }}</v-icon>
      <div class="flex-grow-1">
        <strong>{{ title }}</strong>
        <div class="text-caption grey--text">{{ description }}</div>
      </div>
      <v-icon v-if="isSelected" color="primary">mdi-check-circle</v-icon>
    </div>
    <v-expand-transition>
      <div v-if="isSelected && hasContent" class="mt-3 ml-8">
        <slot />
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  name: "SelectableCard",
  props: {
    value: {
      type: [String, Boolean, Number],
      required: true,
    },
    currentValue: {
      type: [String, Boolean, Number],
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      default: "primary",
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    last: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isSelected() {
      return this.currentValue === this.value;
    },
    hasContent() {
      return !!this.$slots.default;
    },
  },
  methods: {
    handleClick() {
      this.$emit("select", this.value);
    },
  },
};
</script>

<style scoped>
.clickable-card {
  cursor: pointer;
  transition: all 0.2s;
}

.clickable-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.selected-card {
  border-color: #4caf50 !important;
  border-width: 2px !important;
  background-color: rgba(76, 175, 80, 0.04) !important;
}
</style>
